module.exports = __webpack_public_path__ + "Hotels.png?d290c32f644052e634e5ce8198735e73";